import React from "react";
import { ArticleStates } from "@/entities";

interface Props {
  defaultValue: any;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  value: string;
}
export function ArticleStatesSelect({ defaultValue, onChange, value }: Props) {
  return (
    <select
      className="form-select form-select-md"
      onChange={onChange}
      value={value}
    >
      <option value={defaultValue.key}>{defaultValue.value}</option>
      {ArticleStates?.filter((item) => item.key !== "delete").map(
        (item, index) => {
          return (
            <option key={index} value={item.key}>
              {item.value}
            </option>
          );
        }
      )}
    </select>
  );
}
